class OriginalCollectionBannerCrayon {
  constructor() {
    this._dataEl = document.querySelector('.js-collection-banner-crayon-data[type="application/json"]');
    this._crayon = document.querySelector(".js-collection-banner-crayon");
    if (!this._dataEl || !this._crayon) {
      return;
    }
    this._applyRandomColor();
  }
  _applyRandomColor() {
    let colors;
    try {
      colors = JSON.parse(this._dataEl.textContent.trim() || "[]");
    } catch {
      return;
    }
    if (!Array.isArray(colors) || colors.length === 0) {
      return;
    }
    const index = Math.floor(Math.random() * colors.length);
    const picked = colors[index];
    if (typeof picked !== "string" || picked.trim() === "") {
      return;
    }
    this._crayon.style.color = picked.trim();
  }
}
document.addEventListener("DOMContentLoaded", () => {
  new OriginalCollectionBannerCrayon();
});
document.getElementById("js-header");
document.getElementById("js-hamburgerBtn");
document.getElementById("js-fullScreenOverlay");
document.getElementById("js-floatingMenu");
document.getElementById("js-toTop");
document.getElementById("js-globalNav");
class OriginalDetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector("details");
    this.summary = this.details.querySelector("summary");
    this.content = this.summary.nextElementSibling;
    this.summary.addEventListener("click", this.toggleDetails.bind(this));
  }
  toggleDetails(event) {
    event.preventDefault();
    if (this.details.hasAttribute("open")) {
      this.closeDetails();
    } else {
      this.openDetails();
    }
  }
  openDetails() {
    this.details.setAttribute("open", "true");
    this.details.classList.add("is-open");
    this.content.animate(this.openingAnimation(), this.animationSettings());
  }
  closeDetails() {
    this.details.classList.remove("is-open");
    const closingAnim = this.content.animate(this.closingAnimation(), this.animationSettings());
    closingAnim.onfinish = () => {
      this.details.removeAttribute("open");
    };
  }
  openingAnimation() {
    return [
      { height: "0px", opacity: 0 },
      { height: `${this.content.scrollHeight}px`, opacity: 1 }
    ];
  }
  closingAnimation() {
    return [
      { height: `${this.content.scrollHeight}px`, opacity: 1 },
      { height: "0px", opacity: 0 }
    ];
  }
  animationSettings() {
    return {
      duration: 300,
      easing: "ease"
    };
  }
}
customElements.define("original-details-disclosure", OriginalDetailsDisclosure);
class OriginalDialog extends HTMLElement {
  constructor() {
    super();
    this.dialogElement = this.querySelector(".js-dialog");
    this.toggleButtons = this.querySelectorAll(".js-dialogToggle");
    this.dialogElement.addEventListener("click", (event) => {
      if (event.target === this.dialogElement) {
        this.toggleDialog();
      }
    });
    this.toggleButtons.forEach((button) => {
      button.addEventListener("click", this.toggleDialog.bind(this));
    });
  }
  /**
   * Toggle dialog visibility based on its current state
   */
  toggleDialog() {
    if (this.isDialogOpen()) {
      this.closeDialog();
    } else {
      this.openDialog();
    }
  }
  /**
   * Check if the dialog is currently open
   * @returns {Boolean} True if the dialog is open
   */
  isDialogOpen() {
    return this.dialogElement.hasAttribute("open");
  }
  /**
   * Open the dialog and add necessary event listeners
   */
  openDialog() {
    if (typeof this.dialogElement.showModal === "function") {
      this.dialogElement.showModal();
    } else {
      console.error("The <dialog> API is not supported by this browser");
    }
  }
  /**
  * Close the dialog and remove event listeners
  */
  closeDialog() {
    this.dialogElement.close();
  }
}
customElements.define("original-dialog", OriginalDialog);
class OriginalFaq extends HTMLElement {
  constructor() {
    super();
    this._items = [];
  }
  connectedCallback() {
    this._items = Array.from(this.querySelectorAll(".js-faq-item"));
    this._items.forEach((details) => this._setupItem(details));
  }
  _setupItem(details) {
    const summary = details.querySelector(".js-faq-question");
    const wrapper = details.querySelector(".js-faq-answer-wrapper");
    if (!summary || !wrapper) return;
    const setHeight = (height) => {
      wrapper.style.height = height === "" ? "" : height + "px";
    };
    const setInitialState = () => {
      if (details.open) {
        details.classList.add("is-expanded");
        wrapper.classList.add("is-open");
        setHeight("");
      } else {
        details.classList.remove("is-expanded");
        wrapper.classList.remove("is-open");
        wrapper.classList.remove("is-collapsing");
        setHeight(0);
      }
    };
    setInitialState();
    summary.addEventListener("click", (e) => {
      e.preventDefault();
      if (wrapper.classList.contains("is-collapsing")) return;
      if (details.open) {
        this._close(details, wrapper, setHeight);
      } else {
        this._closeAllOthers(details);
        this._open(details, wrapper, setHeight);
      }
    });
  }
  _closeAllOthers(currentDetails) {
    this._items.forEach((details) => {
      if (details !== currentDetails && details.open) {
        const wrapper = details.querySelector(".js-faq-answer-wrapper");
        if (wrapper) {
          const setHeight = (height) => {
            wrapper.style.height = height === "" ? "" : height + "px";
          };
          this._close(details, wrapper, setHeight);
        }
      }
    });
  }
  _close(details, wrapper, setHeight) {
    details.classList.remove("is-expanded");
    const startHeight = wrapper.offsetHeight;
    wrapper.style.height = startHeight + "px";
    wrapper.offsetHeight;
    wrapper.classList.add("is-collapsing");
    wrapper.classList.remove("is-open");
    setHeight(0);
    wrapper.addEventListener(
      "transitionend",
      () => {
        wrapper.classList.remove("is-collapsing");
        setHeight("");
        details.removeAttribute("open");
      },
      { once: true }
    );
  }
  _open(details, wrapper, setHeight) {
    details.setAttribute("open", "");
    details.classList.add("is-expanded");
    wrapper.classList.add("is-collapsing");
    setHeight(0);
    wrapper.offsetHeight;
    const endHeight = wrapper.scrollHeight;
    setHeight(endHeight);
    wrapper.addEventListener(
      "transitionend",
      () => {
        wrapper.classList.remove("is-collapsing");
        wrapper.classList.add("is-open");
        setHeight("");
      },
      { once: true }
    );
  }
}
customElements.define("original-faq", OriginalFaq);
function normalizeWheelDeltaYForHero(event) {
  var _a;
  const pageHeight = ((_a = document.scrollingElement) == null ? void 0 : _a.clientHeight) || window.innerHeight;
  switch (event.deltaMode) {
    case WheelEvent.DOM_DELTA_LINE:
      return event.deltaY * 16;
    case WheelEvent.DOM_DELTA_PAGE:
      return event.deltaY * pageHeight;
    case WheelEvent.DOM_DELTA_PIXEL:
    default:
      return event.deltaY;
  }
}
function wheelTargetHasInnerScrollableAncestor(target, heroRoot) {
  const root = document.scrollingElement || document.documentElement;
  let node = target instanceof Node ? target : null;
  while (node && node !== root && node !== document.documentElement) {
    if (heroRoot instanceof Element && heroRoot.contains(node)) {
      node = node.parentElement;
      continue;
    }
    if (node instanceof Element) {
      const style = window.getComputedStyle(node);
      const oy = style.overflowY;
      const scrollableY = (oy === "auto" || oy === "scroll" || oy === "overlay") && node.scrollHeight > node.clientHeight + 1;
      if (scrollableY) {
        return true;
      }
    }
    node = node.parentElement;
  }
  return false;
}
const HERO_WHEEL_LISTENER_OPTIONS = { passive: false, capture: true };
const HERO_TOUCH_START_OPTIONS = { passive: true, capture: true };
const HERO_TOUCH_MOVE_OPTIONS = { passive: false, capture: true };
const HERO_TOUCH_END_OPTIONS = { passive: true, capture: true };
function easeInOutQuad(t) {
  return t < 0.5 ? 2 * t * t : 1 - (-2 * t + 2) ** 2 / 2;
}
function scrollWindowYInstant(y) {
  try {
    window.scrollTo({ left: 0, top: y, behavior: "instant" });
  } catch {
    window.scrollTo(0, y);
  }
}
function scrollWindowYSmooth(y) {
  try {
    window.scrollTo({ left: 0, top: y, behavior: "smooth" });
  } catch {
    window.scrollTo(0, y);
  }
}
function scrollWindowYEased(y, durationMs = 260) {
  const startY = window.scrollY;
  const delta = y - startY;
  if (Math.abs(delta) < 0.5) {
    scrollWindowYInstant(y);
    return;
  }
  const startAt = performance.now();
  const step = (now) => {
    const elapsed = now - startAt;
    const progress = Math.min(1, elapsed / durationMs);
    const eased = easeInOutQuad(progress);
    window.scrollTo(0, startY + delta * eased);
    if (progress < 1) {
      window.requestAnimationFrame(step);
    } else {
      scrollWindowYInstant(y);
    }
  };
  window.requestAnimationFrame(step);
}
class OriginalHero {
  constructor(element) {
    this.element = element;
    this.swiperInstance = null;
    this.wheelProgress = 0;
    this.isAutoScrolling = false;
        /** スマホ: ヒーロースナップ用の1本指ジェスチャー追跡 */
    this._heroTouchActive = false;
    this._touchLastY = 0;
    this._touchLastX = 0;
    this._heroSnapRafId = null;
    this._savedScrollBehavior = null;
    this._savedDocumentOverflow = null;
    this.onWheelBound = this.onWheel.bind(this);
    this.onTouchStartHeroSnapBound = this.onTouchStartHeroSnap.bind(this);
    this.onTouchMoveHeroSnapBound = this.onTouchMoveHeroSnap.bind(this);
    this.onTouchEndHeroSnapBound = this.onTouchEndHeroSnap.bind(this);
    this._onTouchMoveDuringHeroSnapBound = this._onTouchMoveDuringHeroSnap.bind(this);
    this._onKeyDownDuringHeroSnapBound = this._onKeyDownDuringHeroSnap.bind(this);
    this.init();
  }
 init() {
  try {
    this.initSwiper();
  } catch {
    /* Swiper 未読込などで失敗してもヒーロースナップは有効にする */
  }
  this.initHeroSnapScroll();
}
  initSwiper() {
    const swiperElement = this.element.querySelector(".js-hero-swiper");
    if (!swiperElement) return;
    const slides = this.element.querySelectorAll(".swiper-slide");
    if (slides.length === 0) return;
    if (typeof Swiper === "undefined") {
      return;
    }
    const hasMultipleSlides = slides.length > 1;
    /* テーマのブレークポイントに合わせ SP(749px以下)ではスワイプでスライド変更しない。縦スクロール検知を優先 */
    this.swiperInstance = new Swiper(swiperElement, {
      effect: "fade",
      fadeEffect: {
        crossFade: true
      },
      speed: 1e3,
      autoplay: hasMultipleSlides ? {
        delay: 5e3,
        disableOnInteraction: false
      } : false,
      loop: hasMultipleSlides,
      allowTouchMove: false,
      breakpoints: {
        750: {
          allowTouchMove: hasMultipleSlides
        }
      }
    });
  }
  initHeroSnapScroll() {
    if (typeof window.Shopify !== "undefined" && window.Shopify.designMode) {
      return;
    }
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return;
    }
    window.addEventListener("wheel", this.onWheelBound, HERO_WHEEL_LISTENER_OPTIONS);
        /*
     * タッチは window ではなくヒーロー要素へ。touchstart のターゲットに touchmove が届く仕様のため、
     * iOS での preventDefault とジェスチャー判定が安定する。.p-hero に touch-action: none 必須。
     */
    this.element.addEventListener("touchstart", this.onTouchStartHeroSnapBound, HERO_TOUCH_START_OPTIONS);
    this.element.addEventListener("touchmove", this.onTouchMoveHeroSnapBound, HERO_TOUCH_MOVE_OPTIONS);
    this.element.addEventListener("touchend", this.onTouchEndHeroSnapBound, HERO_TOUCH_END_OPTIONS);
    this.element.addEventListener("touchcancel", this.onTouchEndHeroSnapBound, HERO_TOUCH_END_OPTIONS);
  }
  /**
   * ヒーロー手前での下方向スワイプ開始（1本指のみ追跡）
   */
  onTouchStartHeroSnap(event) {
    if (this.isAutoScrolling) {
      return;
    }
    if (event.touches.length !== 1) {
      this._heroTouchActive = false;
      return;
    }
    this._heroTouchActive = true;
    const t = event.touches[0];
    this._touchLastY = t.clientY;
    this._touchLastX = t.clientX;
  }
  /**
   * 指を上に動かす量を蓄積し、しきい値でヒーロー下端へ自動スクロール（wheel と同ロジック）
   */
  onTouchMoveHeroSnap(event) {
    if (!this._heroTouchActive || event.touches.length !== 1) {
      return;
    }
    if (this.isAutoScrolling) {
      return;
    }
    const t = event.touches[0];
    const clientY = t.clientY;
    const clientX = t.clientX;
    const scrollTop = window.scrollY;
    const heroRect = this.element.getBoundingClientRect();
    const heroBottomDocumentY = scrollTop + heroRect.bottom;
    const isBeforeHeroBottom = scrollTop < heroBottomDocumentY - 0.5;
    if (!isBeforeHeroBottom) {
      this._touchLastY = clientY;
      this._touchLastX = clientX;
      this.wheelProgress = 0;
      return;
    }
    const deltaY = this._touchLastY - clientY;
    const deltaX = this._touchLastX - clientX;
    this._touchLastY = clientY;
    this._touchLastX = clientX;
    if (deltaY <= 0) {
      this.wheelProgress = 0;
      return;
    }
    /*
     * SP では縦方向の意図を優先: 横方向の動きが縦を大きく上回るフレームは蓄積しない（誤検知を減らす）
     */
    const isSp = typeof window.matchMedia === "function" && window.matchMedia("(max-width: 749px)").matches;
    if (isSp && Math.abs(deltaX) > Math.abs(deltaY) * 1.25) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    this.wheelProgress += deltaY;
    const touchThreshold = isSp ? OriginalHero.WHEEL_TRIGGER_DISTANCE_TOUCH_SP : OriginalHero.WHEEL_TRIGGER_DISTANCE;
    if (this.wheelProgress < touchThreshold) {
      return;
    }
    this.wheelProgress = 0;
    this._heroTouchActive = false;
    this.isAutoScrolling = true;
    this._applyHeroSnapUserInputLock();
    this.runHeroSnapScroll(OriginalHero.HERO_SNAP_SCROLL_DURATION_MS, () => {
      this._restoreHeroSnapUserInputLock();
      this.isAutoScrolling = false;
    });
  }
  /**
   * ジェスチャー終了時は未達分の蓄積をリセット（次のスワイプからやり直し）
   */
  onTouchEndHeroSnap(event) {
    if (event.touches.length === 0) {
      this._heroTouchActive = false;
      if (!this.isAutoScrolling) {
        this.wheelProgress = 0;
      }
    }
  }
  onWheel(event) {
    if (event.ctrlKey) {
      return;
    }
    if (this.isAutoScrolling) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    const scrollTop = window.scrollY;
    const heroRect = this.element.getBoundingClientRect();
    const heroBottomDocumentY = scrollTop + heroRect.bottom;
    const isBeforeHeroBottom = scrollTop < heroBottomDocumentY - 0.5;
    const deltaYPx = normalizeWheelDeltaYForHero(event);
    if (!isBeforeHeroBottom) {
      this.wheelProgress = 0;
      return;
    }
    if (deltaYPx <= 0) {
      this.wheelProgress = 0;
      return;
    }
    if (wheelTargetHasInnerScrollableAncestor(event.target, this.element)) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    this.wheelProgress += deltaYPx;
    if (this.wheelProgress < OriginalHero.WHEEL_TRIGGER_DISTANCE) {
      return;
    }
    this.wheelProgress = 0;
    this.isAutoScrolling = true;
    this._applyHeroSnapUserInputLock();
    this.runHeroSnapScroll(OriginalHero.HERO_SNAP_SCROLL_DURATION_MS, () => {
      this._restoreHeroSnapUserInputLock();
      this.isAutoScrolling = false;
    });
  }
  /**
   * 自動スクロール中はホイール・タッチ・キーによるスクロールを無効化
   */
  _applyHeroSnapUserInputLock() {
    if (this._savedDocumentOverflow !== null) {
      return;
    }
    const html = document.documentElement;
    const body = document.body;
    this._savedDocumentOverflow = {
      htmlOverflow: html.style.overflow,
      htmlOverflowX: html.style.overflowX,
      bodyOverflow: body.style.overflow,
      bodyOverflowX: body.style.overflowX
    };
    html.style.overflow = "hidden";
    html.style.overflowX = "hidden";
    body.style.overflow = "hidden";
    body.style.overflowX = "hidden";
    window.addEventListener("touchmove", this._onTouchMoveDuringHeroSnapBound, {
      passive: false,
      capture: true
    });
    window.addEventListener("keydown", this._onKeyDownDuringHeroSnapBound, { capture: true });
  }
  _restoreHeroSnapUserInputLock() {
    if (this._savedDocumentOverflow === null) {
      return;
    }
    window.removeEventListener("touchmove", this._onTouchMoveDuringHeroSnapBound, {
      passive: false,
      capture: true
    });
    window.removeEventListener("keydown", this._onKeyDownDuringHeroSnapBound, { capture: true });
    const o = this._savedDocumentOverflow;
    const html = document.documentElement;
    const body = document.body;
    html.style.overflow = o.htmlOverflow;
    html.style.overflowX = o.htmlOverflowX;
    body.style.overflow = o.bodyOverflow;
    body.style.overflowX = o.bodyOverflowX;
    this._savedDocumentOverflow = null;
  }
  /**
   * @param {TouchEvent} event
   */
  _onTouchMoveDuringHeroSnap(event) {
    if (!this.isAutoScrolling) {
      return;
    }
    event.preventDefault();
  }
  /**
   * @param {KeyboardEvent} event
   */
  _onKeyDownDuringHeroSnap(event) {
    if (!this.isAutoScrolling) {
      return;
    }
    const scrollKeys = /* @__PURE__ */ new Set([" ", "PageDown", "PageUp", "ArrowDown", "ArrowUp", "Home", "End"]);
    if (!scrollKeys.has(event.key)) {
      return;
    }
    const target = event.target;
    if (target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement || target instanceof HTMLSelectElement) {
      return;
    }
    if (target instanceof HTMLElement && target.isContentEditable) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
  }
  /**
   * html/body の scroll-behavior を一時的に auto にし、CSS smooth との二重補間を防ぐ
   */
  _applyScrollBehaviorLock() {
    if (this._savedScrollBehavior !== null) {
      return;
    }
    const html = document.documentElement;
    const body = document.body;
    this._savedScrollBehavior = {
      html: html.style.scrollBehavior,
      body: body.style.scrollBehavior
    };
    html.style.scrollBehavior = "auto";
    body.style.scrollBehavior = "auto";
  }
  _restoreScrollBehavior() {
    if (this._savedScrollBehavior === null) {
      return;
    }
    const { html, body } = this._savedScrollBehavior;
    document.documentElement.style.scrollBehavior = html;
    document.body.style.scrollBehavior = body;
    this._savedScrollBehavior = null;
  }
  /**
   * 指定時間で window.scrollY をヒーロー下端まで補間
   * ホイール直後のちらつきを抑えるため 1 フレーム遅らせ、開始・終了で位置を明示する
   * @param {number} durationMs
   * @param {() => void} onComplete
   */
  runHeroSnapScroll(durationMs, onComplete) {
    if (this._heroSnapRafId != null) {
      window.cancelAnimationFrame(this._heroSnapRafId);
    }

    // kari
    const finalizeHeroSnap = () => {
      const alignToHeroBottom = (useSmooth = false) => {
        const remain = this.element.getBoundingClientRect().bottom;
        console.log('aaaa',remain);
        if (remain > 0.5) {
          const targetY = window.scrollY + remain;
          if (useSmooth) {
            scrollWindowYEased(targetY);
          } else {
            scrollWindowYInstant(targetY);
          }
          waitForScrollEnd(targetY);
        }else {
          setTimeout(() => { 
            document.documentElement.classList.remove('is-hero-snapping'); 
            console.log('削除（remain小さい）');
          }, 400);
        }
      };

      const waitForScrollEnd = (targetY) => {
        console.log('bbbb');
        const check = () => {
          if (Math.abs(window.scrollY - targetY) < 2) {
            setTimeout(() => { 
              document.documentElement.classList.remove('is-hero-snapping'); 
              console.log('削除');
            }, 400);
          } else {
            requestAnimationFrame(check);
          }
        };
        check();
      };

      alignToHeroBottom();
      this._heroSnapRafId = null;
      this._restoreScrollBehavior();
      onComplete();
      this._heroSnapRafId = window.requestAnimationFrame(() => {
        this._heroSnapRafId = null;
        alignToHeroBottom(true);
      });
    };
    // kari

    this._heroSnapRafId = window.requestAnimationFrame(() => {
      this._applyScrollBehaviorLock();
      scrollWindowYInstant(window.scrollY);
      const rect = this.element.getBoundingClientRect();
      const targetY = window.scrollY + rect.bottom;
      const startY = window.scrollY;
      const delta = targetY - startY;
      if (Math.abs(delta) < 0.5) {
        // this._heroSnapRafId = null;
        // this._restoreScrollBehavior();
        // onComplete();
        document.documentElement.classList.add('is-hero-snapping');
        finalizeHeroSnap();
        return;
      }
      scrollWindowYInstant(startY);
      const timeStart = performance.now();
      const step = (now) => {
        const elapsed = now - timeStart;
        const linearProgress = Math.min(1, elapsed / durationMs);
        if (linearProgress >= 1) {
          scrollWindowYInstant(targetY);
          // this._heroSnapRafId = null;
          // this._restoreScrollBehavior();
          // onComplete();
          document.documentElement.classList.add('is-hero-snapping');
          finalizeHeroSnap();
          return;
        }
        const y = startY + delta * easeInOutQuad(linearProgress);
        window.scrollTo(0, y);
        this._heroSnapRafId = window.requestAnimationFrame(step);
      };
      this._heroSnapRafId = window.requestAnimationFrame(step);
    });
  }
  destroy() {
    if (this._heroSnapRafId != null) {
      window.cancelAnimationFrame(this._heroSnapRafId);
      this._heroSnapRafId = null;
    }
    this._restoreScrollBehavior();
    this._restoreHeroSnapUserInputLock();
    this.isAutoScrolling = false;
    window.removeEventListener("wheel", this.onWheelBound, HERO_WHEEL_LISTENER_OPTIONS);
    this.element.removeEventListener("touchstart", this.onTouchStartHeroSnapBound, HERO_TOUCH_START_OPTIONS);
    this.element.removeEventListener("touchmove", this.onTouchMoveHeroSnapBound, HERO_TOUCH_MOVE_OPTIONS);
    this.element.removeEventListener("touchend", this.onTouchEndHeroSnapBound, HERO_TOUCH_END_OPTIONS);
    this.element.removeEventListener("touchcancel", this.onTouchEndHeroSnapBound, HERO_TOUCH_END_OPTIONS);
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
    }
  }
}
OriginalHero.WHEEL_TRIGGER_DISTANCE = 300;
/** SP タッチ: 縦スワイプで溜めやすくする（px 相当の蓄積） */
OriginalHero.WHEEL_TRIGGER_DISTANCE_TOUCH_SP = 140;
OriginalHero.HERO_SNAP_SCROLL_DURATION_MS = 750;
/**
 * index テンプレートの image-with-text セクションで、
 * 一定スクロール量を超えたら次セクションへ自動スクロールする。
 */
class OriginalImageWithTextIndexSnap {
  constructor(element) {
    this.element = element;
    this.wheelProgress = 0;
    this.isAutoScrolling = false;
    this._sectionTouchActive = false;
    this._touchLastY = 0;
    this._touchLastX = 0;
    this._sectionSnapRafId = null;
    this._savedScrollBehavior = null;
    this._savedDocumentOverflow = null;
    this.onWheelBound = this.onWheel.bind(this);
    this.onTouchStartBound = this.onTouchStart.bind(this);
    this.onTouchMoveBound = this.onTouchMove.bind(this);
    this.onTouchEndBound = this.onTouchEnd.bind(this);
    this._onTouchMoveDuringSnapBound = this._onTouchMoveDuringSnap.bind(this);
    this._onKeyDownDuringSnapBound = this._onKeyDownDuringSnap.bind(this);
    this.init();
  }
  init() {
    if (typeof window.Shopify !== "undefined" && window.Shopify.designMode) {
      return;
    }
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return;
    }
    window.addEventListener("wheel", this.onWheelBound, HERO_WHEEL_LISTENER_OPTIONS);
    this.element.addEventListener("touchstart", this.onTouchStartBound, HERO_TOUCH_START_OPTIONS);
    this.element.addEventListener("touchmove", this.onTouchMoveBound, HERO_TOUCH_MOVE_OPTIONS);
    this.element.addEventListener("touchend", this.onTouchEndBound, HERO_TOUCH_END_OPTIONS);
    this.element.addEventListener("touchcancel", this.onTouchEndBound, HERO_TOUCH_END_OPTIONS);
  }
  onTouchStart(event) {
    if (this.isAutoScrolling) {
      return;
    }
    if (event.touches.length !== 1) {
      this._sectionTouchActive = false;
      return;
    }
    this._sectionTouchActive = true;
    const t = event.touches[0];
    this._touchLastY = t.clientY;
    this._touchLastX = t.clientX;
  }
  onTouchMove(event) {
    if (!this._sectionTouchActive || event.touches.length !== 1) {
      return;
    }
    if (this.isAutoScrolling) {
      return;
    }
    const t = event.touches[0];
    const clientY = t.clientY;
    const clientX = t.clientX;
    const scrollTop = window.scrollY;
    const sectionRect = this.element.getBoundingClientRect();
    const sectionTopDocumentY = scrollTop + sectionRect.top;
    const sectionBottomDocumentY = scrollTop + sectionRect.bottom;
    const isWithinSectionRange = scrollTop >= sectionTopDocumentY - 0.5 && scrollTop < sectionBottomDocumentY - 0.5;
    const isBeforeSectionBottom = scrollTop < sectionBottomDocumentY - 0.5;
    if (!isWithinSectionRange || !isBeforeSectionBottom) {
      this._touchLastY = clientY;
      this._touchLastX = clientX;
      this.wheelProgress = 0;
      return;
    }
    const deltaY = this._touchLastY - clientY;
    const deltaX = this._touchLastX - clientX;
    this._touchLastY = clientY;
    this._touchLastX = clientX;
    if (deltaY <= 0) {
      this.wheelProgress = 0;
      return;
    }
    const isSp = typeof window.matchMedia === "function" && window.matchMedia("(max-width: 749px)").matches;
    if (isSp && Math.abs(deltaX) > Math.abs(deltaY) * 1.25) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    this.wheelProgress += deltaY;
    const touchThreshold = isSp ? OriginalImageWithTextIndexSnap.WHEEL_TRIGGER_DISTANCE_TOUCH_SP : OriginalImageWithTextIndexSnap.WHEEL_TRIGGER_DISTANCE;
    if (this.wheelProgress < touchThreshold) {
      return;
    }
    this.wheelProgress = 0;
    this._sectionTouchActive = false;
    this.isAutoScrolling = true;
    this._applyUserInputLock();
    this.runSnapScroll(OriginalImageWithTextIndexSnap.SNAP_SCROLL_DURATION_MS, () => {
      this._restoreUserInputLock();
      this.isAutoScrolling = false;
    });
  }
  onTouchEnd(event) {
    if (event.touches.length === 0) {
      this._sectionTouchActive = false;
      if (!this.isAutoScrolling) {
        this.wheelProgress = 0;
      }
    }
  }
  onWheel(event) {
    if (event.ctrlKey) {
      return;
    }
    if (this.isAutoScrolling) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    const scrollTop = window.scrollY;
    const sectionRect = this.element.getBoundingClientRect();
    const sectionTopDocumentY = scrollTop + sectionRect.top;
    const sectionBottomDocumentY = scrollTop + sectionRect.bottom;
    const isWithinSectionRange = scrollTop >= sectionTopDocumentY - 0.5 && scrollTop < sectionBottomDocumentY - 0.5;
    const isBeforeSectionBottom = scrollTop < sectionBottomDocumentY - 0.5;
    const deltaYPx = normalizeWheelDeltaYForHero(event);
    if (!isWithinSectionRange || !isBeforeSectionBottom) {
      this.wheelProgress = 0;
      return;
    }
    if (deltaYPx <= 0) {
      this.wheelProgress = 0;
      return;
    }
    if (wheelTargetHasInnerScrollableAncestor(event.target, this.element)) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    this.wheelProgress += deltaYPx;
    if (this.wheelProgress < OriginalImageWithTextIndexSnap.WHEEL_TRIGGER_DISTANCE) {
      return;
    }
    this.wheelProgress = 0;
    this.isAutoScrolling = true;
    this._applyUserInputLock();
    this.runSnapScroll(OriginalImageWithTextIndexSnap.SNAP_SCROLL_DURATION_MS, () => {
      this._restoreUserInputLock();
      this.isAutoScrolling = false;
    });
  }
  _applyUserInputLock() {
    if (this._savedDocumentOverflow !== null) {
      return;
    }
    const html = document.documentElement;
    const body = document.body;
    this._savedDocumentOverflow = {
      htmlOverflow: html.style.overflow,
      htmlOverflowX: html.style.overflowX,
      bodyOverflow: body.style.overflow,
      bodyOverflowX: body.style.overflowX
    };
    html.style.overflow = "hidden";
    html.style.overflowX = "hidden";
    body.style.overflow = "hidden";
    body.style.overflowX = "hidden";
    window.addEventListener("touchmove", this._onTouchMoveDuringSnapBound, {
      passive: false,
      capture: true
    });
    window.addEventListener("keydown", this._onKeyDownDuringSnapBound, { capture: true });
  }
  _restoreUserInputLock() {
    if (this._savedDocumentOverflow === null) {
      return;
    }
    window.removeEventListener("touchmove", this._onTouchMoveDuringSnapBound, {
      passive: false,
      capture: true
    });
    window.removeEventListener("keydown", this._onKeyDownDuringSnapBound, { capture: true });
    const o = this._savedDocumentOverflow;
    const html = document.documentElement;
    const body = document.body;
    html.style.overflow = o.htmlOverflow;
    html.style.overflowX = o.htmlOverflowX;
    body.style.overflow = o.bodyOverflow;
    body.style.overflowX = o.bodyOverflowX;
    this._savedDocumentOverflow = null;
  }
  _onTouchMoveDuringSnap(event) {
    if (!this.isAutoScrolling) {
      return;
    }
    event.preventDefault();
  }
  _onKeyDownDuringSnap(event) {
    if (!this.isAutoScrolling) {
      return;
    }
    const scrollKeys = /* @__PURE__ */ new Set([" ", "PageDown", "PageUp", "ArrowDown", "ArrowUp", "Home", "End"]);
    if (!scrollKeys.has(event.key)) {
      return;
    }
    const target = event.target;
    if (target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement || target instanceof HTMLSelectElement) {
      return;
    }
    if (target instanceof HTMLElement && target.isContentEditable) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
  }
  _applyScrollBehaviorLock() {
    if (this._savedScrollBehavior !== null) {
      return;
    }
    const html = document.documentElement;
    const body = document.body;
    this._savedScrollBehavior = {
      html: html.style.scrollBehavior,
      body: body.style.scrollBehavior
    };
    html.style.scrollBehavior = "auto";
    body.style.scrollBehavior = "auto";
  }
  _restoreScrollBehavior() {
    if (this._savedScrollBehavior === null) {
      return;
    }
    const { html, body } = this._savedScrollBehavior;
    document.documentElement.style.scrollBehavior = html;
    document.body.style.scrollBehavior = body;
    this._savedScrollBehavior = null;
  }
  runSnapScroll(durationMs, onComplete) {
    if (this._sectionSnapRafId != null) {
      window.cancelAnimationFrame(this._sectionSnapRafId);
    }
    this._sectionSnapRafId = window.requestAnimationFrame(() => {
      this._applyScrollBehaviorLock();
      scrollWindowYInstant(window.scrollY);
      const rect = this.element.getBoundingClientRect();
      const targetY = window.scrollY + rect.bottom;
      const startY = window.scrollY;
      const delta = targetY - startY;
      if (Math.abs(delta) < 0.5) {
        this._sectionSnapRafId = null;
        this._restoreScrollBehavior();
        onComplete();
        return;
      }
      scrollWindowYInstant(startY);
      const timeStart = performance.now();
      const step = (now) => {
        const elapsed = now - timeStart;
        const linearProgress = Math.min(1, elapsed / durationMs);
        if (linearProgress >= 1) {
          scrollWindowYInstant(targetY);
          this._sectionSnapRafId = null;
          this._restoreScrollBehavior();
          onComplete();
          return;
        }
        const y = startY + delta * easeInOutQuad(linearProgress);
        window.scrollTo(0, y);
        this._sectionSnapRafId = window.requestAnimationFrame(step);
      };
      this._sectionSnapRafId = window.requestAnimationFrame(step);
    });
  }
  destroy() {
    if (this._sectionSnapRafId != null) {
      window.cancelAnimationFrame(this._sectionSnapRafId);
      this._sectionSnapRafId = null;
    }
    this._restoreScrollBehavior();
    this._restoreUserInputLock();
    this.isAutoScrolling = false;
    window.removeEventListener("wheel", this.onWheelBound, HERO_WHEEL_LISTENER_OPTIONS);
    this.element.removeEventListener("touchstart", this.onTouchStartBound, HERO_TOUCH_START_OPTIONS);
    this.element.removeEventListener("touchmove", this.onTouchMoveBound, HERO_TOUCH_MOVE_OPTIONS);
    this.element.removeEventListener("touchend", this.onTouchEndBound, HERO_TOUCH_END_OPTIONS);
    this.element.removeEventListener("touchcancel", this.onTouchEndBound, HERO_TOUCH_END_OPTIONS);
  }
}
OriginalImageWithTextIndexSnap.WHEEL_TRIGGER_DISTANCE = 300;
OriginalImageWithTextIndexSnap.WHEEL_TRIGGER_DISTANCE_TOUCH_SP = 140;
OriginalImageWithTextIndexSnap.SNAP_SCROLL_DURATION_MS = 750;
document.addEventListener("DOMContentLoaded", () => {
  const heroSections = document.querySelectorAll(".js-hero-section");
  heroSections.forEach((section) => {
    new OriginalHero(section);
  });
  const imageWithTextIndexSections = document.querySelectorAll(".js-image-with-text-index-section");
  imageWithTextIndexSections.forEach((section) => {
    new OriginalImageWithTextIndexSnap(section);
  });
});
class OriginalListCollectionsToggle {
  constructor() {
    this.toggleCheckbox = null;
    this.gridElement = null;
    this.storageKey = "list-collections-display-mode";
    this.init();
  }
  init() {
    this.toggleCheckbox = document.querySelector(".js-list-collections-toggle");
    this.gridElement = document.querySelector(".js-list-collections-grid");
    if (!this.toggleCheckbox || !this.gridElement) {
      return;
    }
    this.loadSavedState();
    this.attachEventListeners();
  }
  attachEventListeners() {
    this.toggleCheckbox.addEventListener("change", this.handleToggleChange.bind(this));
  }
  handleToggleChange() {
    const isChecked = this.toggleCheckbox.checked;
    this.updateDisplayMode(isChecked);
    this.saveState(isChecked);
  }
  updateDisplayMode(isTwoColumn) {
    if (isTwoColumn) {
      this.gridElement.classList.add("is-two-column");
    } else {
      this.gridElement.classList.remove("is-two-column");
    }
  }
  saveState(isTwoColumn) {
    try {
      localStorage.setItem(this.storageKey, isTwoColumn ? "two-column" : "stack");
    } catch (error) {
      console.warn("localStorage保存に失敗しました:", error);
    }
  }
  loadSavedState() {
    try {
      const savedMode = localStorage.getItem(this.storageKey);
      const isTwoColumn = savedMode === "two-column";
      this.toggleCheckbox.checked = isTwoColumn;
      this.updateDisplayMode(isTwoColumn);
    } catch (error) {
      console.warn("localStorage読み込みに失敗しました:", error);
    }
  }
}
document.addEventListener("DOMContentLoaded", () => {
  new OriginalListCollectionsToggle();
});
class OriginalModal extends HTMLElement {
  constructor() {
    super();
    this.modalElement = this.querySelector(".js-modal");
    this.toggleButtons = this.querySelectorAll(".js-modalToggle");
    this.previousScrollPosition = 0;
    this.toggleButtons.forEach((button) => {
      button.addEventListener("click", this.toggleModal.bind(this));
    });
  }
  /**
   * Toggle modal visibility based on its current state
   */
  toggleModal() {
    if (this.isModalOpen()) {
      this.closeModal();
    } else {
      this.openModal();
    }
  }
  /**
   * Check if the modal is currently open
   * @returns {Boolean} True if the modal is open
   */
  isModalOpen() {
    return this.hasAttribute("open");
  }
  /**
   * Open the modal and add necessary event listeners
   */
  openModal() {
    this.setAttribute("open", "true");
    window.addEventListener("keydown", this.handleKeyboardFocus.bind(this), { capture: true });
    document.addEventListener("touchmove", this.preventScroll, { passive: false });
    this.fixScrollLock(this.modalElement);
    this.setFocusToFirstButton(this.modalElement);
  }
  /**
   * Close the modal and remove event listeners
   */
  closeModal() {
    this.removeAttribute("open");
    window.removeEventListener("keydown", this.handleKeyboardFocus.bind(this), { capture: true });
    document.removeEventListener("touchmove", this.preventScroll);
    this.removeScrollLockFix(this.modalElement);
    this.toggleButtons[0].focus();
  }
  /**
   * Handle keyboard interactions inside the modal
   */
  handleKeyboardFocus(event) {
    this.controlModalFocus(event, this.modalElement, this.closeModal.bind(this));
  }
  /**
   * Set focus to either the first or last button inside the modal
   * @param {DOM} parentElement The modal element
   * @param {Boolean} isFirstFocus Whether to focus on the first or last button
   */
  setFocusToFirstButton(parentElement, isFirstFocus = true) {
    if (!parentElement) {
      throw new Error("Modal element not found");
    }
    const focusableElements = this.getFocusableElements(parentElement);
    if (focusableElements.length > 0) {
      focusableElements[isFirstFocus ? 0 : focusableElements.length - 1].focus();
    }
  }
  /**
   * Control modal keyboard focus behavior (e.g., trapping focus, handling Escape)
   * @param {Event} event
   * @param {DOM} parentElement The modal element
   * @param {Function} onClose Function to close the modal
   */
  controlModalFocus(event, parentElement, onClose) {
    if (!parentElement) return;
    switch (event.code) {
      case "Enter":
      case "Space":
        break;
      case "Escape":
        onClose();
        break;
      case "Tab": {
        const focusableElements = this.getFocusableElements(parentElement);
        const currentIndex = focusableElements.findIndex((el) => el === document.activeElement);
        if (focusableElements.length === 1) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.setFocusToFirstButton(parentElement, true);
        } else if (currentIndex === 0 && event.shiftKey) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.setFocusToFirstButton(parentElement, false);
        } else if (currentIndex >= focusableElements.length - 1 && !event.shiftKey) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.setFocusToFirstButton(parentElement, true);
        } else if (currentIndex === -1) {
          this.setFocusToFirstButton(parentElement, true);
        }
        break;
      }
    }
  }
  /**
   * Get all focusable elements within the modal
   * @param {DOM} modalElement The modal element
   * @returns {Array} An array of focusable elements
   */
  getFocusableElements(modalElement) {
    const focusableSelector = "button, a";
    return Array.from(modalElement.querySelectorAll(focusableSelector));
  }
  /**
   * Prevent scrolling on the document except for the modal
   * @param {Event} event The scroll event
   */
  preventScroll(event) {
    var _a;
    const isScrollableElement = (_a = event.target) == null ? void 0 : _a.closest(this.modalElement);
    if (!isScrollableElement || !this.isElementScrollable(isScrollableElement)) {
      event.preventDefault();
    } else {
      event.stopPropagation();
    }
  }
  /**
   * Fix scroll issues when modal is open
   * @param {DOM} modalElement The modal element
   */
  fixScrollLock(modalElement) {
    if (this.isWindows()) {
      this.applyWindowsScrollLock();
    } else {
      document.body.classList.add("is-scrollLock");
    }
    modalElement.addEventListener("scroll", this.handleScrollBug);
  }
  /**
   * Remove scroll lock fixes
   * @param {DOM} modalElement The modal element
   */
  removeScrollLockFix(modalElement) {
    if (this.isWindows()) {
      this.removeWindowsScrollLock();
    } else {
      document.body.classList.remove("is-scrollLock");
    }
    modalElement.removeEventListener("scroll", this.handleScrollBug);
  }
  /**
   * Check if the element is scrollable
   * @param {DOM} element The element to check
   * @returns {Boolean} True if the element is scrollable
   */
  isElementScrollable(element) {
    return element.clientHeight < element.scrollHeight;
  }
  /**
   * Handle scroll-related bugs in specific scenarios
   * @param {Event} event
   */
  handleScrollBug(event) {
    const element = event.target;
    if (!element) return;
    if (element.scrollTop + element.clientHeight === element.scrollHeight) {
      element.scrollTop -= 1;
    }
    if (element.scrollTop === 0) {
      element.scrollTop = 1;
    }
  }
  /**
   * Detect if the operating system is Windows
   * @returns {Boolean} True if the OS is Windows
   */
  isWindows() {
    return window.navigator.userAgent.toLowerCase().includes("windows nt");
  }
  /**
   * Apply scroll lock fix for Windows
   */
  applyWindowsScrollLock() {
    this.previousScrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
    document.body.classList.add("is-scrollLock-windows");
    document.body.style.top = `-${this.previousScrollPosition}px`;
  }
  /**
   * Remove scroll lock fix for Windows
   */
  removeWindowsScrollLock() {
    document.body.classList.remove("is-scrollLock-windows");
    document.body.style.top = "initial";
    document.body.scrollTop = this.previousScrollPosition;
    document.documentElement.scrollTop = this.previousScrollPosition;
  }
}
customElements.define("original-modal", OriginalModal);
class OriginalSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector(".js-slider");
    this.buttonPrev = this.querySelector(".js-sliderNavigationPrev");
    this.buttonNext = this.querySelector(".js-sliderNavigationNext");
    this.pagination = this.querySelector(".js-sliderPagination");
    this.sliderInstance = null;
  }
  initializeSlider(sliderOptions) {
    if (!this.slider) {
      console.error("Slider element not found.");
      return;
    }
    if (this.sliderInstance) {
      this.sliderInstance.destroy(true, true);
    }
    this.sliderInstance = new Swiper(this.slider, {
      ...sliderOptions,
      ...this.buttonPrev && this.buttonNext ? {
        navigation: {
          nextEl: this.buttonNext,
          prevEl: this.buttonPrev
        }
      } : {},
      ...this.pagination ? {
        pagination: {
          el: this.pagination,
          clickable: true
        }
      } : {}
    });
  }
}
customElements.define("original-slider", OriginalSlider);
class OriginalVariantSelects extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.addEventListener("change", (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);
      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues
        }
      });
    });
  }
  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;
    if (tagName === "SELECT" && target.selectedOptions.length) {
      Array.from(target.options).find((option) => option.getAttribute("selected")).removeAttribute("selected");
      target.selectedOptions[0].setAttribute("selected", "selected");
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target.closest(".js-productFormInput").querySelector("[data-selected-value] > .js-swatch");
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty("--swatch--background", swatchValue);
        selectedDropdownSwatchValue.classList.remove("is-unavailable");
      } else {
        selectedDropdownSwatchValue.style.setProperty("--swatch--background", "unset");
        selectedDropdownSwatchValue.classList.add("is-unavailable");
      }
      selectedDropdownSwatchValue.style.setProperty(
        "--swatch-focal-point",
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || "unset"
      );
    } else if (tagName === "INPUT" && target.type === "radio") {
      const selectedSwatchValue = target.closest(`.js-productFormInput`).querySelector("[data-selected-value]");
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }
  getInputForEventTarget(target) {
    return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
  }
  get selectedOptionValues() {
    return Array.from(this.querySelectorAll("select option[selected], fieldset input:checked")).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}
customElements.define("original-variant-selects", OriginalVariantSelects);
document.addEventListener("DOMContentLoaded", floatingMenuDisplayControl, false);
window.addEventListener("scroll", floatingMenuDisplayControl, false);
if (TO_TOP) {
  TO_TOP.addEventListener("click", toTop, false);
}
if (HAMBURGER) {
  HAMBURGER.addEventListener("click", drawerDisplayControl, false);
}
if (FULL_SCREEN_OVERLAY) {
  FULL_SCREEN_OVERLAY.addEventListener("click", drawerDisplayControl, false);
}
document.addEventListener("DOMContentLoaded", linkWithinPageControl, false);
